export function appendStyle(target, styles) {
    for (const style in styles) {
        target.style[style] = styles[style] ?? '';
    }
}
//# sourceMappingURL=append-style.js.map